/* eslint-disable no-restricted-globals */
import { Dialog } from "@mui/material";
import { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { toast } from "react-toastify";
import {
  Box,
  ButtonPrimary,
  ButtonPrimary1,
  ButtonSecondary,
  HStack,
  VStack,
} from "../../../../components/utils";
import {
  EmployeeOfferDetails,
  MonetaryDetailsV2,
  TransactionDetailsData,
} from "../../../../types/Transaction";
import {
  MonetaryEventState,
  OfferState,
} from "../../../../types/OptionBuyback";
import { Select } from "../../../../components/shared/Select";
import {
  Input,
  Label,
  TextArea,
} from "../../../../components/shared/InputField";

function StatusChangeDialog({
  open,
  employees,
  onClose,
  onSubmit,
  loading,
  setMetaData,
  metaData,
}: {
  open: boolean;
  employees?: EmployeeOfferDetails[];
  onClose: () => void;
  onSubmit: (status: OfferState) => void;
  loading?: boolean;
  setMetaData?: (data: any) => void;
  metaData?: any;
}) {
  const formik = useFormikContext<TransactionDetailsData>();

  const [selectedStatus, setSelectedStatus] = useState<OfferState | null>(null);

  const formatDate = (dateStr: string) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toISOString().slice(0, 10);
  };

  const [monetaryDetails, setMonetaryDetails] =
    useState<MonetaryDetailsV2 | null>();
  const [monetaryTransactionDetails, setMonetaryTransactionDetails] =
    useState<any>(null);

  useEffect(() => {
    if (employees && employees.length > 0) {
      setMonetaryDetails(
        employees[0].monetaryTransactionDetails?.monetaryDetails || null
      );
      setMonetaryTransactionDetails(
        employees[0].monetaryTransactionDetails || null
      );
    }
  }, [employees]);

  const handleSubmit = () => {
    if (selectedStatus) {
      if (
        (selectedStatus === OfferState.WILLINGNESS_ACCEPTED ||
          selectedStatus === OfferState.ACCEPTED ||
          selectedStatus === OfferState.PENDING_EXERCISED) &&
        !metaData?.exerciseDate &&
        !formik.values.monetaryDetails.transactionPaymentEnabled
      ) {
        toast.error("Exercise date is required");
        return;
      }
      onSubmit(selectedStatus);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <VStack className="">
        <div className="p-4 mt-4 text-lg font-medium border-b selection:ml-3 stone-700">
          <h6 className="flex justify-between">
            Change Status for {employees?.length} Employees
            <span onClick={() => onClose()} className="cursor-pointer">
              X
            </span>
          </h6>
        </div>
        <div className="p-4">
          <Label className="text-sm font-medium">Select Next State</Label>
          <Select
            className=""
            value={selectedStatus ?? ""}
            textGetter={(item: OfferState) => item.replaceAll("_", " ")}
            options={[
              // If employee already signed (ACCEPTED) → only path forward is PENDING_EXERCISED
              employees?.every((e) => e.offerState === OfferState.ACCEPTED)
                ? OfferState.PENDING_EXERCISED
                : monetaryDetails?.generateExerciseLetters ||
                  monetaryDetails?.employeeSignatureRequired
                ? OfferState.WILLINGNESS_ACCEPTED
                : OfferState.PENDING_EXERCISED,
              OfferState.REJECTED,
            ]}
            onChange={(e: any) =>
              setSelectedStatus(e.target.value as OfferState)
            }
          ></Select>
        </div>
        {!formik.values.monetaryDetails.transactionPaymentEnabled &&
          selectedStatus !== "REJECTED" && (
            <div className="p-4">
              <Label className="text-sm font-medium">Exercise Date</Label>
              <Box>
                <Input
                  type="date"
                  value={
                    metaData?.exerciseDate
                      ? formatDate(metaData.exerciseDate)
                      : ""
                  }
                  onChange={(e) => {
                    if (!e.target.value) return;
                    if (setMetaData)
                      setMetaData((prev: any) => ({
                        ...prev,
                        exerciseDate: new Date(e.target.value),
                      }));
                  }}
                />
              </Box>
            </div>
          )}
        {!formik.values.monetaryDetails.transactionPaymentEnabled &&
          selectedStatus !== "REJECTED" && (
            <div className="p-4">
              <Label className="text-sm font-medium">Exercise Details</Label>
              <Box>
                <TextArea
                  value={metaData?.exerciseDetails || ""}
                  onChange={(e) => {
                    if (!e.target.value) return;
                    if (setMetaData)
                      setMetaData((prev: any) => ({
                        ...prev,
                        exerciseDetails: e.target.value,
                      }));
                  }}
                />
              </Box>
            </div>
          )}
        {!formik.values.monetaryDetails.transactionPaymentEnabled &&
          selectedStatus !== "REJECTED" && (
            <div className="p-4">
              <Label className="text-sm font-medium">Tax Details</Label>
              <Box>
                <TextArea
                  value={metaData?.taxDetails || ""}
                  onChange={(e) => {
                    if (!e.target.value) return;
                    if (setMetaData)
                      setMetaData((prev: any) => ({
                        ...prev,
                        taxDetails: e.target.value,
                      }));
                  }}
                />
              </Box>
            </div>
          )}
        <HStack className="justify-between gap-2 p-4">
          <ButtonPrimary1 onClick={onClose}>Cancel</ButtonPrimary1>
          <ButtonPrimary
            onClick={handleSubmit}
            disabled={!selectedStatus || loading}
            loading={loading}
          >
            Confirm
          </ButtonPrimary>
        </HStack>
      </VStack>
    </Dialog>
  );
}

export default StatusChangeDialog;
